import { c as _c } from "react/compiler-runtime";
import { cx } from 'class-variance-authority';
import { type ButtonHTMLAttributes, forwardRef } from 'react';
type FilterButtonProps = ButtonHTMLAttributes<HTMLButtonElement> & {
  children: React.ReactNode;
  hasFilters?: boolean;
  onClick?: () => void;
  className?: string;
};
const FilterButton = forwardRef<HTMLButtonElement, FilterButtonProps>((t0, ref) => {
  const $ = _c(16);
  let children;
  let className;
  let hasFilters;
  let onClick;
  let props;
  if ($[0] !== t0) {
    ({
      children,
      onClick,
      hasFilters,
      className,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = className;
    $[3] = hasFilters;
    $[4] = onClick;
    $[5] = props;
  } else {
    children = $[1];
    className = $[2];
    hasFilters = $[3];
    onClick = $[4];
    props = $[5];
  }
  const t1 = !hasFilters;
  let t2;
  if ($[6] !== className || $[7] !== hasFilters || $[8] !== t1) {
    t2 = cx("text-label-3 h-8 inline-flex items-center justify-center bg-primary px-3 border rounded-(--button-border-radius)", "transition-all duration-200 ease-in-out w-fit whitespace-nowrap", "cursor-pointer hover:bg-hover-control", {
      "text-primary border-tertiary": t1,
      "text-accent border-secondary": hasFilters
    }, className);
    $[6] = className;
    $[7] = hasFilters;
    $[8] = t1;
    $[9] = t2;
  } else {
    t2 = $[9];
  }
  let t3;
  if ($[10] !== children || $[11] !== onClick || $[12] !== props || $[13] !== ref || $[14] !== t2) {
    t3 = <button {...props} ref={ref} onClick={onClick} type="button" className={t2}>{children}</button>;
    $[10] = children;
    $[11] = onClick;
    $[12] = props;
    $[13] = ref;
    $[14] = t2;
    $[15] = t3;
  } else {
    t3 = $[15];
  }
  return t3;
});
export default FilterButton;